// Generated code; do not edit.
// You might be looking for: packages/bank-schemas/bank.graphql
// To regenerate: yarn workspaces foreach -A run generate-types

import type * as Types from '../../gqltypes';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import {
  EmployeeFragmentDoc,
  AutofillDataFragmentDoc,
} from '../../common-queries.generated';
import { MinimalInvitationFragmentDoc } from '../../queries.generated';
export type ExportPageDataQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ExportPageDataQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly state: Types.OrgState;
    readonly name: string;
    readonly onboardingDate: string;
    readonly accountingSystemInfo: {
      readonly __typename: 'AccountingSystemInfo';
      readonly systemId: Types.AccountingSystem;
    };
    readonly exportData: {
      readonly __typename: 'ExportData';
      readonly periods: {
        readonly __typename: 'ExportPeriods';
        readonly monthly: ReadonlyArray<{
          readonly __typename: 'ExportPeriod';
          readonly startDate: string;
          readonly endDate: string;
          readonly status: Types.ExportPeriodStatus;
          readonly label: string;
          readonly path: string;
        }>;
      };
    };
    readonly exportAccounts: {
      readonly __typename: 'ExportAccounts';
      readonly taxAccount: {
        readonly __typename: 'Account';
        readonly accountNumber: string;
      } | null;
    };
  };
};

export type SetAccountingSystemInfoMutationVariables = Types.Exact<{
  systemId: Types.AccountingSystem;
}>;

export type SetAccountingSystemInfoMutation = {
  readonly __typename: 'Mutation';
  readonly setAccountingSystemInfo: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly accountingSystemInfo: {
      readonly __typename: 'AccountingSystemInfo';
      readonly systemId: Types.AccountingSystem;
    };
  };
  readonly dismissAgentHint: {
    readonly __typename: 'Agent';
    readonly fid: string;
    readonly activeHints: ReadonlyArray<{
      readonly __typename: 'AgentHint';
      readonly kind: Types.AgentHintKind;
      readonly dismissable: boolean;
      readonly targets: ReadonlyArray<Types.Target>;
    }>;
  };
};

export type ExportServiceStatusQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ExportServiceStatusQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly accountingSystemInfo: {
      readonly __typename: 'AccountingSystemInfo';
      readonly systemId: Types.AccountingSystem;
      readonly exportService: {
        readonly __typename: 'ExportService';
        readonly status: Types.ExportServiceStatus | null;
      } | null;
    };
  };
};

export type ExportStatusQueryVariables = Types.Exact<{ [key: string]: never }>;

export type ExportStatusQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly accountingSystemInfo: {
      readonly __typename: 'AccountingSystemInfo';
      readonly systemId: Types.AccountingSystem;
      readonly exportService: {
        readonly __typename: 'ExportService';
        readonly status: Types.ExportServiceStatus | null;
        readonly records: ReadonlyArray<
          | {
              readonly __typename: 'ActiveExportRecord';
              readonly progress: number;
              readonly id: string;
            }
          | { readonly __typename: 'ErrorExportRecord'; readonly id: string }
          | { readonly __typename: 'SuccessExportRecord'; readonly id: string }
        >;
      } | null;
      readonly monthExportStatuses: ReadonlyArray<{
        readonly __typename: 'PeriodExportableStatus';
        readonly startDate: string;
        readonly endDate: string;
        readonly state: Types.PeriodExportableState;
        readonly incompleteEvents: ReadonlyArray<{
          readonly __typename: 'Event';
          readonly fid: string;
          readonly requirements: {
            readonly __typename: 'EventRequirements';
            readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
            readonly metRequirementCount: number;
            readonly totalRequirementCount: number;
            readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
          };
        }>;
        readonly mostRecentExport:
          | {
              readonly __typename: 'ActiveExportRecord';
              readonly progress: number;
              readonly id: string;
            }
          | {
              readonly __typename: 'ErrorExportRecord';
              readonly id: string;
              readonly error:
                | { readonly __typename: 'ClosedPeriodIntegrationExportError' }
                | {
                    readonly __typename: 'ClosedVatPeriodIntegrationExportError';
                  }
                | { readonly __typename: 'GenericIntegrationExportError' }
                | {
                    readonly __typename: 'InvalidReceiptFileIntegrationExportError';
                  };
            }
          | { readonly __typename: 'SuccessExportRecord'; readonly id: string }
          | null;
      }>;
    };
  };
};

export type DisableExportIntegrationMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type DisableExportIntegrationMutation = {
  readonly __typename: 'Mutation';
  readonly disableExportIntegration: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly accountingSystemInfo: {
      readonly __typename: 'AccountingSystemInfo';
      readonly systemId: Types.AccountingSystem;
      readonly exportService: {
        readonly __typename: 'ExportService';
        readonly status: Types.ExportServiceStatus | null;
      } | null;
    };
  };
};

export type ExportPeriodMutationVariables = Types.Exact<{
  startDate: Types.Scalars['IsoUtcDate'];
  endDate: Types.Scalars['IsoUtcDate'];
}>;

export type ExportPeriodMutation = {
  readonly __typename: 'Mutation';
  readonly triggerExport: string;
};

export type AllEmployeesQueryVariables = Types.Exact<{ [key: string]: never }>;

export type AllEmployeesQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly employeesWithCards: ReadonlyArray<{
      readonly __typename: 'EmployeeWithCard';
      readonly agent: {
        readonly __typename: 'Agent';
        readonly fid: string;
        readonly avatarId: Types.AvatarId;
        readonly email: string | null;
        readonly mobileNumber: string | null;
        readonly state: Types.AgentState;
        readonly type: Types.AgentType;
        readonly structuredName: {
          readonly __typename: 'Name';
          readonly full: string;
          readonly first: string | null;
          readonly legal: string | null;
        };
        readonly latestPromotion: {
          readonly __typename: 'Promotion';
          readonly fid: string;
          readonly state: Types.PromotionState;
          readonly fromType: Types.AgentType | null;
          readonly toType: Types.AgentType;
          readonly initiatedBy: {
            readonly __typename: 'Agent';
            readonly fid: string;
            readonly structuredName: {
              readonly __typename: 'Name';
              readonly full: string;
            };
          };
        } | null;
        readonly signingJobs: ReadonlyArray<{
          readonly __typename: 'SigningJob';
          readonly type: Types.SigningType;
          readonly url: string | null;
        }>;
        readonly cardAccount: {
          readonly __typename: 'CardAccount';
          readonly accountNumber: string;
          readonly account: {
            readonly __typename: 'Account';
            readonly accountNumber: string;
            readonly balanceNok: {
              readonly __typename: 'AmountInfo';
              readonly asNumber: number;
            } | null;
            readonly autofill: {
              readonly __typename: 'Autofill';
              readonly desiredAmount: string;
              readonly lowLimit: string;
              readonly dailyLimit: string;
              readonly isDailyLimitReached: boolean;
            } | null;
          };
          readonly card: {
            readonly __typename: 'Card';
            readonly fid: string;
            readonly lastFourDigits: string | null;
            readonly state: Types.CardState;
            readonly expirationYear: number;
            readonly expirationMonth: number;
          } | null;
        } | null;
      };
    }>;
    readonly invitations: ReadonlyArray<{
      readonly __typename: 'Invitation';
      readonly fid: string;
      readonly key: string;
      readonly state: Types.InvitationState;
      readonly email: string;
      readonly createdAt: string;
    }>;
  };
};

export type ReconciliationStatusQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type ReconciliationStatusQuery = {
  readonly __typename: 'Query';
  readonly organization: {
    readonly __typename: 'Organization';
    readonly orgNum: string;
    readonly accountingSystemInfo: {
      readonly __typename: 'AccountingSystemInfo';
      readonly systemId: Types.AccountingSystem;
    };
    readonly orgReconciliationInfo: ReadonlyArray<{
      readonly __typename: 'MonthReconciliationInfo';
      readonly month: string;
      readonly state: Types.ReconciliationState;
      readonly incompleteEvents: ReadonlyArray<{
        readonly __typename: 'Event';
        readonly fid: string;
        readonly requirements: {
          readonly __typename: 'EventRequirements';
          readonly allRequirements: ReadonlyArray<Types.EventRequirement>;
          readonly metRequirementCount: number;
          readonly totalRequirementCount: number;
          readonly unmetRequirements: ReadonlyArray<Types.EventRequirement>;
        };
      }>;
    }>;
  };
};

export const ExportPageDataDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportPageData' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'onboardingDate' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingSystemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exportData' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'periods' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'monthly' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'startDate' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'endDate' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'status' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'label' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'path' },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'exportAccounts' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'taxAccount' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'accountNumber' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportPageDataQuery, ExportPageDataQueryVariables>;
export const SetAccountingSystemInfoDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'SetAccountingSystemInfo' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'systemId' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'AccountingSystem' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'setAccountingSystemInfo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'systemId' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'systemId' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingSystemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemId' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'dismissAgentHint' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'hint' },
                value: {
                  kind: 'EnumValue',
                  value: 'afterAccountantInvitationApproved',
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'fid' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'activeHints' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'kind' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'dismissable' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'targets' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SetAccountingSystemInfoMutation,
  SetAccountingSystemInfoMutationVariables
>;
export const ExportServiceStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportServiceStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingSystemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exportService' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportServiceStatusQuery,
  ExportServiceStatusQueryVariables
>;
export const ExportStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ExportStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingSystemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exportService' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'records' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'ActiveExportRecord',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'progress',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'monthExportStatuses' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'startDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'endDate' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'state' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'incompleteEvents' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'fid' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'requirements',
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'allRequirements',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'metRequirementCount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'totalRequirementCount',
                                          },
                                        },
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'unmetRequirements',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'mostRecentExport' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'id' },
                                  },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'ActiveExportRecord',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'progress',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                  {
                                    kind: 'InlineFragment',
                                    typeCondition: {
                                      kind: 'NamedType',
                                      name: {
                                        kind: 'Name',
                                        value: 'ErrorExportRecord',
                                      },
                                    },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'Field',
                                          name: {
                                            kind: 'Name',
                                            value: 'error',
                                          },
                                          selectionSet: {
                                            kind: 'SelectionSet',
                                            selections: [
                                              {
                                                kind: 'Field',
                                                name: {
                                                  kind: 'Name',
                                                  value: '__typename',
                                                },
                                              },
                                            ],
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ExportStatusQuery, ExportStatusQueryVariables>;
export const DisableExportIntegrationDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'DisableExportIntegration' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disableExportIntegration' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingSystemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemId' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'exportService' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'status' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  DisableExportIntegrationMutation,
  DisableExportIntegrationMutationVariables
>;
export const ExportPeriodDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'ExportPeriod' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'startDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IsoUtcDate' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'endDate' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'IsoUtcDate' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'triggerExport' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'startDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'startDate' },
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'endDate' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'endDate' },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ExportPeriodMutation,
  ExportPeriodMutationVariables
>;
export const AllEmployeesDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'AllEmployees' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'employeesWithCards' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agent' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'FragmentSpread',
                              name: { kind: 'Name', value: 'Employee' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'invitations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'MinimalInvitation' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...EmployeeFragmentDoc.definitions,
    ...AutofillDataFragmentDoc.definitions,
    ...MinimalInvitationFragmentDoc.definitions,
  ],
} as unknown as DocumentNode<AllEmployeesQuery, AllEmployeesQueryVariables>;
export const ReconciliationStatusDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'ReconciliationStatus' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organization' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'orgNum' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'accountingSystemInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'systemId' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'orgReconciliationInfo' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'month' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'state' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'incompleteEvents' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'fid' },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'requirements' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'allRequirements',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'metRequirementCount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'totalRequirementCount',
                                    },
                                  },
                                  {
                                    kind: 'Field',
                                    name: {
                                      kind: 'Name',
                                      value: 'unmetRequirements',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  ReconciliationStatusQuery,
  ReconciliationStatusQueryVariables
>;
